module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conInner"
  }, [_c('section', {
    attrs: {
      "id": "content_wrapper"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/gth.jpg"
    }
  }), _vm._v(" "), _c('div', [_c('h2', [_vm._v("温馨提示")]), _vm._v(" "), _c('p', [_vm._v("1、"), _c('router-link', {
    attrs: {
      "to": {
        path: '/help',
        query: {
          articleid: 14
        }
      }
    }
  }, [_vm._v("我怎么进行退换货？")])], 1), _vm._v(" "), _c('p', [_vm._v("2、这里会显示您更多的订单。")]), _vm._v(" "), _c('p', [_vm._v("3、您还可以查看申请列表、申请退换货等操作。")])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('ul', [_c('li', {
    class: {
      'selected': _vm.tab == 1
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.changeTab(1)
      }
    }
  }, [_c('span', [_vm._v("申请退换货")])])]), _vm._v(" "), _c('li', {
    class: {
      'selected': _vm.tab == 2
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.changeTab(2)
      }
    }
  }, [_c('span', [_vm._v("申请列表")])])])])]), _vm._v(" "), _c('div', {
    class: {
      white_box: _vm.tab == 1,
      form_wrap: _vm.tab == 1
    }
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), (_vm.tab == 1) ? _c('div', {
    staticStyle: {
      "padding": "20px",
      "border-left": "1px solid #DBDBDB",
      "border-right": "1px solid #DBDBDB"
    },
    attrs: {
      "id": "ivu-form"
    }
  }, [_c('Form', {
    ref: "returnData",
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "model": _vm.returnData,
      "rules": _vm.ruleValidate,
      "label-width": 150
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "类型",
      "prop": "type"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.returnData.type),
      callback: function($$v) {
        _vm.$set(_vm.returnData, "type", $$v)
      },
      expression: "returnData.type"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("退货")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("换货")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "所属订单",
      "prop": "order_sn"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请填写订单号,一次只能输入一个订单号"
    },
    model: {
      value: (_vm.returnData.orderSn),
      callback: function($$v) {
        _vm.$set(_vm.returnData, "orderSn", $$v)
      },
      expression: "returnData.orderSn"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "商品货号",
      "prop": "goodsns"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入订单的商品货号"
    },
    model: {
      value: (_vm.returnData.goodsns),
      callback: function($$v) {
        _vm.$set(_vm.returnData, "goodsns", $$v)
      },
      expression: "returnData.goodsns"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "申请理由",
      "prop": "reason"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请选择申请理由",
      "transfer": true
    },
    model: {
      value: (_vm.returnData.reason),
      callback: function($$v) {
        _vm.$set(_vm.returnData, "reason", $$v)
      },
      expression: "returnData.reason"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("商品描述不符")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("少件/漏发")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("卖家发错货")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("包装/商品破损")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("假冒品牌")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("未按约定时间发货")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("未收到货")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("发票问题")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("不合适/不喜欢")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("质量问题")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("换货")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("其他问题")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "申请描述",
      "prop": "desc"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      },
      "placeholder": "请填写申请描述"
    },
    model: {
      value: (_vm.returnData.desc),
      callback: function($$v) {
        _vm.$set(_vm.returnData, "desc", $$v)
      },
      expression: "returnData.desc"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "margin-bottom": "0!important"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('returnData')
      }
    }
  }, [_vm._v("申请提交")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": function($event) {
        return _vm.handleReset('returnData')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tab == 2) ? _c('div', {
    staticClass: "body"
  }, [(!_vm.returnsOrderList.length) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("暂无信息")]) : _vm._e(), _vm._v(" "), (_vm.returnsOrderList.length) ? _c('table', {
    staticClass: "liststyle",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "3"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.returnsOrderList), function(row) {
    return _c('tr', {
      staticClass: "hovertr"
    }, [_c('td', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.formatDate(row.createTime)))]), _vm._v(" "), _c('td', {
      staticClass: "orderId"
    }, [_vm._v(_vm._s(row.orderNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.typeText))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.applyReason))]), _vm._v(" "), _c('td', [_c('span', {
      attrs: {
        "title": row.applyDesc
      }
    }, [_vm._v(_vm._s(_vm._f("limitToNum")(row.applyDesc, 10)))])]), _vm._v(" "), _c('td', {
      staticClass: "status"
    }, [(row.state == 0) ? _c('span', [_vm._v("申请已提交")]) : _vm._e(), _vm._v(" "), (row.state == 1) ? _c('span', [_vm._v("已拒绝")]) : _vm._e(), _vm._v(" "), (row.state == 2) ? _c('span', [_vm._v("已通过审核")]) : _vm._e(), _vm._v(" "), (row.state == 3) ? _c('span', [_vm._v("退货已收货")]) : _vm._e(), _vm._v(" "), (row.state == 4) ? _c('span', [_vm._v("完成")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "oper",
      attrs: {
        "width": "100"
      }
    }, [(row.state == 0) ? _c('a', {
      staticClass: "del_favorite link blue",
      on: {
        "click": function($event) {
          return _vm.cancleSq(row.returnOrderId)
        }
      }
    }, [_vm._v("取消申请")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "del_favorite link blue",
      on: {
        "click": function($event) {
          return _vm.toOrderDetail(row.orderNo)
        }
      }
    }, [_vm._v("查看")]), _vm._v(" "), (row.state == 2) ? _c('a', {
      staticClass: "del_favorite link blue",
      on: {
        "click": function($event) {
          return _vm.recordDetail(row.orderNo)
        }
      }
    }, [_vm._v("退回补录")]) : _vm._e()])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.returnsOrderList.length) ? _c('div', {
    staticClass: "pager_border"
  }, [_c('Page', {
    ref: "pages",
    attrs: {
      "total": _vm.dataTotal,
      "show-total": "",
      "page-size": _vm.pageSize,
      "size": "small",
      "show-elevator": ""
    },
    on: {
      "on-change": _vm.changepage
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })])])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "填写退回快递单号"
    },
    model: {
      value: (_vm.recordModal),
      callback: function($$v) {
        _vm.recordModal = $$v
      },
      expression: "recordModal"
    }
  }, [_c('div', {
    staticClass: "mb-10 p-l50"
  }, [_c('label', [_vm._v("快递公司：")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.logistics),
      callback: function($$v) {
        _vm.logistics = $$v
      },
      expression: "logistics"
    }
  }, _vm._l((_vm.logisticsList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-10 p-l50"
  }, [_c('label', [_vm._v("快递单号：")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "284px"
    },
    attrs: {
      "placeholder": "请填写快递单号"
    },
    model: {
      value: (_vm.logisticsSn),
      callback: function($$v) {
        _vm.logisticsSn = $$v
      },
      expression: "logisticsSn"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    staticClass: "ivu-btn ivu-btn-primary ivu-btn-large",
    attrs: {
      "size": "large"
    },
    on: {
      "click": _vm.asyncOK
    }
  }, [_vm._v("提交")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data"
  }, [_c('h2', [_vm._v("申请退换货")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('th', {
    staticClass: "date"
  }, [_vm._v("申请时间")]), _vm._v(" "), _c('th', [_vm._v("订单号")]), _vm._v(" "), _c('th', [_vm._v("申请类型")]), _vm._v(" "), _c('th', [_vm._v("申请理由")]), _vm._v(" "), _c('th', [_vm._v("申请描述")]), _vm._v(" "), _c('th', [_vm._v("状态")]), _vm._v(" "), _c('th', [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a98a017"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/member-center/right/returnList.vue
// module id = 1558
// module chunks = 1